<div class="main-container" [class]="themeService.getTheme()">
  <app-section-scroller>
    <app-main-visit (mainLoading)="visitEmit($event)"/>
  </app-section-scroller>
  <app-section-scroller [height]="isMobile ? window.innerHeight + 5 : window.innerHeight">
    <app-main-destinations (ClickOnActive)="goToDestination($event)" (loadingEmit)="circleEmit($event)" [mode]="'Continents'"/>
  </app-section-scroller>
  <app-section>
    <div [style]="!isMobile ? 'padding-top: 35px; background: var(--background-color);' : 'background: var(--background-color);'">
      <app-main-best-hotels
      *ngIf="hotels.length > 0"
      [texts]="mainBestHotelsTitle"
      [search]="true"
      [subtitle]="true"
      />
    </div>
    <app-main-busy-bee
      [cards]="CardsArray"
      [texts]="mainBusyBeeTitle"
    />
    <app-accordion-slider/>
    <app-main-busy-bee
      [cards]="CardsArrayVoyagesNew"
      [texts]="mainVoyagesTitle"
    />
  </app-section>
</div>

